<script lang="ts" context="module">

    type CardType = 'BingoMex' | 'BingoAnimals' | 'BingoCartoon' | 'Movies' | 'MoviesKids' | 'XMas' | 'Football' | 'Halloween' | 'Superheroes' | 'Cartoon';

    const cardsSpritesMap: Record<CardType, string> = {
      'BingoMex'                : '/images/mex_cards_small.jpg',
      'BingoAnimals'            : '/images/animal_cards.png',
      'BingoCartoon'            : '/images/cartoon_cards.png',
      'Movies'                  : '/images/movies_cards.jpeg',
      'MoviesKids'              : '/images/kid_movies_cards.jpeg',
      'XMas'                    : '/images/cards_xmas.jpg',
      'Football'                : '/images/cards_football.jpg',
      'Halloween'               : '/images/cards_halloween.png',
      'Superheroes'             : '/images/cards_superheroes.png',
      'Cartoon'                 : '/images/cards_superheroes_cartoon.png'
    };

    const imagesMap = new Map<CardType, Promise<HTMLImageElement>>();

    function getImage(imageName: CardType): Promise<HTMLImageElement> {
        if (!imagesMap.has(imageName)) {
            const promise = new Promise<HTMLImageElement>(resolve => {
                const image = document.createElement('img') as HTMLImageElement;
                image.addEventListener('load', () => resolve(image), { once: true });
                image.src = cardsSpritesMap[imageName];
            });
            imagesMap.set(imageName, promise);
        }
        return imagesMap.get(imageName);
    }

</script>
<script lang="ts">
    
    import { onMount } from "svelte";
    import type { GameType } from "../../global";
    import AspectKeeper from "../Shared/AspectKeeper.svelte";

    export let number: number;
    export let gameType: GameType;

    const width = 321;
    const height = 512;

    let canvas: HTMLCanvasElement;
    let ctx: CanvasRenderingContext2D;

    $: updateBackgroundPostion(ctx, number);

    onMount(() => {
        ctx = canvas.getContext('2d');
    });

    async function updateBackgroundPostion(ctx: CanvasRenderingContext2D, number: number): Promise<void> {
        if (!ctx) {
            return;
        }
        const cardIndex = number - 1;
        const image = await getImage(gameType as CardType);
        const x = cardIndex % 9;
        const y = Math.floor(cardIndex / 9);
        const w = image.naturalWidth / 9;
        const h = image.naturalHeight / 6;
        const ox = w * x;
        const oy = h * y;
        ctx.drawImage(image, ox, oy, w, h, 0, 0, width, height);
    }

</script>

<AspectKeeper ratio={height / width}>
    <canvas bind:this={canvas} {width} {height}></canvas>
</AspectKeeper>

<style lang="scss">

    canvas {
        width: 100%;
        height: 100%;
    }

</style>
